// extracted by mini-css-extract-plugin
export default {"prev-icon":"DayCarousel_prev-icon__sIH39","next-icon":"DayCarousel_next-icon__YJq5X"};